import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckIcon, ArrowRightIcon, LockClosedIcon } from '@radix-ui/react-icons';
import { Button } from '../../components';
import { AuthLayout } from './AuthLayout';
import './Auth.scss';

export const ResetPasswordSuccess: React.FC = () => {
  const navigate = useNavigate();

  return (
    <AuthLayout>
      <div className="auth-card">
        <div className="auth-success-icon" aria-hidden="true">
          <CheckIcon />
        </div>

        <h1 className="auth-title auth-title--center">Password Reset Successful</h1>
        <p className="auth-subtitle auth-subtitle--center">
          Your password has been updated. You can now log in to your account with your new credentials.
        </p>

        <Button
          type="button"
          fullWidth
          className="auth-submit-button"
          onClick={() => navigate('/login')}
        >
          Back to Login
          <ArrowRightIcon aria-hidden="true" />
        </Button>

        <div className="auth-secure-badge">
          <LockClosedIcon aria-hidden="true" />
          100% Secure &amp; Encrypted
        </div>
      </div>
    </AuthLayout>
  );
};
